/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Marcus Biesel <m.biesel@techdivision.com>
 */

import { signal } from '@preact/signals-react';

/**
 * ErrorSignal
 * @returns {{signal: Signal<null>}}
 */
function createErrorSignal() {
  const errorSignal = signal(null);

  return {
    signal: errorSignal,
  };
}

export const errorSignal = createErrorSignal();
